<template>
	<div v-if="loaded">
		<header class="page-title">
			<h2>{{ providerType.translations['en'].name }} &ndash; Summary Settings</h2>
			<div class="ml-auto">
				<a v-if="userRoles.includes('provider_types.settings_update') && !userRoles.includes('users.translator')" @click="addNewSetting" class="btn btn-md btn-primary" href="#"><i class="fas fa-plus"></i> Add New Type</a>
				<a v-if="userRoles.includes('provider_types.settings_update')" @click="saveSettings" class="btn btn-md btn-success" href="#"><i class="fas fa-save"></i> Save Changes</a>
			</div>
		</header>
		<div class="grid--nav-horizontal" v-if="settings.length > 0">
			<nav class="nav-horizontal">
				<ul>
					<li v-for="(setting, index) in settings" @click="selectSetting(index)" :class="[setting.name === selectedSetting.name ? 'active' : '']">
						<a>{{ setting.name }}
							<div class="badge badge-default ml-1">{{ setting.articles_count }}</div>
						</a></li>
				</ul>
			</nav>
			<div class="nav-horizontal-contents">
				<div class="alert alert-warning alert--small">
					<div class="alert-icon fas fa-exclamation-triangle"></div>
					<div class="alert-content">
						<h4>Info</h4>
					</div>
				</div>
				<section v-if="selectedSetting">
					<header class="page-title">
						<h2>{{ selectedSetting.name }}</h2>
						<div class="ml-auto" v-if="!userRoles.includes('users.translator')">
							<a v-if="userRoles.includes('users.developer')" class="btn btn-md btn-danger" href="#" @click.prevent="deleteSetting()"><i class="fas fa-fw fa-trash"></i> Delete Setting</a>
							<a v-if="userRoles.includes('provider_types.settings_update')" class="btn btn-md btn-success" href="#" @click.prevent="addNewRow(selectedSetting)"><i class="fas fa-plus"></i> Add Row</a>
						</div>
					</header>
					<div class="form-group">
						<label for="name">Setting Name</label>
						<input id="name" type="text" :readonly="userRoles.includes('users.translator')" v-model="selectedSetting.name">
					</div>
					<div v-if="selectedSetting.hasOwnProperty('id') && !selectedSetting.is_default" class="form-group">
						<a href="#" class="btn btn-md btn-primary" @click.prevent="makeDefault(selectedSetting.id)" v-if="!userRoles.includes('users.translator')">Make this settings default</a>
					</div>
					<table class="mt-2">
						<tr v-for="(row, index) in selectedSetting.properties">
							<td class="td-with-padding">
								<div class="form-group">
									<label for="review-header-title">Feature Group Title</label>
									<div class="input-group">
										<input id="review-header-title" type="text" v-model="row['en'].title">
										<a href="#" class="btn btn-md btn-primary" @click.prevent="showModal(row)"><i class="fas fa-language icon-left"></i> Translate</a>
									</div>
								</div>
								<div v-if="userRoles.includes('provider_types.settings_update') && !userRoles.includes('users.translator')" class="form-group">
									<label for="add-review-setting-property">Add Property</label>
									<div class="input-group">
										<select id="add-review-setting-property" v-model="row.selectedProperty">
											<option value="null">Select a property</option>
											<optgroup v-for="group in providerType.groups" :label="group.name">
												<option v-for="property in group.properties" :value="property">{{ property.name }}</option>
											</optgroup>
										</select>
										<a href="#" class="btn btn-md btn-primary" @click.prevent="addProperty(row)"><i class="fas fa-plus icon-left"></i> Add</a>
									</div>
								</div>
								<div class="form-group">
									<label>List of Properties</label>
									<table>
										<thead>
											<tr>
												<th></th>
												<th>Property Name</th>
												<th>Actions</th>
											</tr>
										</thead>
										<draggable :tag="'tbody'" @end="drag=false" @start="drag=true" v-model="row.properties">
											<tr v-for="(property, propertyIndex) in row.properties">
												<td class="text-center"><i class="fas fa-grip-lines"></i></td>
												<td>{{ property.name }}</td>
												<td class="actions">
													<a v-if="userRoles.includes('provider_types.settings_update') && !userRoles.includes('users.translator')" href="#" class="btn btn-icon btn-danger" title="Delete" @click.prevent="row.properties.splice(propertyIndex, 1)"><i class="fas fa-fw fa-trash"></i></a>
												</td>
											</tr>
										</draggable>
									</table>
								</div>
							</td>
							<td class="actions text-center">
								<a v-if="userRoles.includes('provider_types.settings_update') && !userRoles.includes('users.translator')" href="#" class="btn btn-icon btn-danger" title="Delete" @click.prevent="deleteRow(selectedSetting, index)"><i class="fas fa-fw fa-trash"></i></a>
							</td>
						</tr>
					</table>
				</section>
			</div>
		</div>
		<div class="modal-bg" v-if="translationModal && selectedRow">
			<div class="modal">
				<header class="modal-header">
					<h4 class="modal-title">Edit Translations</h4>
					<a class="modal-close" title="Close modal" @click.prevent="hideModal"><i class="fas fa-times"></i></a>
				</header>
				<section class="modal-body">
					<div class="card mb-0">
						<header class="card-header language-list">
							<lang-selector></lang-selector>
						</header>
						<div class="card-body">
							<div class="form-group">
								<label for="trans">Translation</label>
								<input id="trans" type="text" v-model="selectedRow[clickedLang].title">
							</div>
						</div>
					</div>
				</section>
				<footer class="modal-footer">
					<a class="btn btn-md btn-success" href="#" @click.prevent="hideModal"><i class="fas fa-check"></i> Confirm</a>
				</footer>
			</div>
		</div>
	</div>
</template>

<script>
	import draggable from 'vuedraggable';
	import Errors from '../../../Utils/Errors.js'
	import {eventBus} from '../../../app';

	export default {
		components: {
			draggable
		},
		props: {
			dataProviderTypeId: {
				type: Number
			}
		},
		data() {
			return {
				providerTypeId: this.dataProviderTypeId,
				tabName: 'providerTypeSummarySettings',
				loaded: false,
				providerType: {},

				selectedSetting: null,
				selectedSettingIndex: null,
				selectedRow: null,
				settings: [],


				translationModal: false,
				clickedLang: this.$defaultLanguage.locale,

				userRoles: this.$currentUserRoles,
				errors: new Errors()
			}
		},
		mounted() {
			this.fetchDataFromApi();
			let vm = this;

			// When setActiveStatus method ran, change selected data in form fields
			/* From LangSelector */
			eventBus.$on('setActiveStatus', function (clickedLang) {
				vm.clickedLang = clickedLang;
			});

		},
		methods: {
			fetchDataFromApi: function () {
				let vm = this;
				eventBus.$emit('onLoaderStart');
				axios.post('/api/' + vm.$selectedSite.slug + '/providertype/fetchtabdata/' + vm.providerTypeId, {
					tab: vm.tabName
				})
					.then(response => {
						if (response.data.hasOwnProperty('data')) {
							if (response.data.data.hasOwnProperty('providerType')) {
								vm.providerType = response.data.data.providerType;
							}
							if (response.data.data.hasOwnProperty('allProviders')) {
								vm.allProviders = response.data.data.allProviders;
							}
							vm.getSettings();
							eventBus.$emit('onLoaderFinish');
							vm.loaded = true;
						}
					})
					.catch(e => {
						eventBus.$emit('onLoaderFinish');
						vm.$toastr.error('Api ' + vm.tabName + ' tab load failed', 'Error');
					});
			},
			showModal: function (row) {
				let vm = this;
				vm.translationModal = true;
				vm.selectedRow = row;
			},
			hideModal: function () {
				let vm = this;
				vm.translationModal = false;
				vm.selectedRow = null;
			},
			addNewSetting: function () {
				let vm = this;
				vm.settings.push({
					name: '',
					properties: []
				});
				vm.selectedSetting = vm.settings[vm.settings.length - 1];
				vm.selectedSettingIndex = vm.settings.length - 1;
			},
			addNewRow: function (selectedSetting) {
				let vm = this;
				vm.selectedSetting.properties.push({
					en: {
						title: ''
					},
					properties: []
				});
			},
			deleteRow: function (selectedSetting, index) {
				let vm = this;
				vm.selectedSetting.properties.splice(index, 1);
			},
			addProperty: function (reviewSetting) {
				let vm = this;
				reviewSetting.properties.push(reviewSetting.selectedProperty);
			},
			selectSetting: function (index) {
				let vm = this;

				if (vm.settings.length > 0) {
					vm.selectedSetting = vm.settings[index];
					vm.selectedSettingIndex = index;

					for (let i = 0; i < vm.$availableLanguages.length; i++) {
						vm.selectedSetting[vm.$availableLanguages[i].locale] = {
							title: (vm.selectedSetting.translations && vm.selectedSetting.translations[vm.$availableLanguages[i].locale]) ? vm.selectedSetting.translations[vm.$availableLanguages[i].locale].title : ''
						};

						for (let j = 0; j < vm.selectedSetting.properties.length; j++) {
							if(!vm.selectedSetting.properties[j].hasOwnProperty(vm.$availableLanguages[i].locale)) {
								vm.selectedSetting.properties[j][vm.$availableLanguages[i].locale] = {
									title: ''
								};
							}
						}
					}
				}
			},
			getSettings: function () {
				let vm = this;
				eventBus.$emit('onLoaderStart');

				axios.get('/api/' + vm.$selectedSite.slug + '/provider-types/' + vm.providerType.id + '/getSettings')
					.then(response => {
						vm.settings = response.data;
						vm.selectSetting(0);
						eventBus.$emit('onLoaderFinish');
						this.$toastr.success('Provider Type settings updated successfully.');
					})
					.catch(e => {
						this.errors.record(e.response.data);
						eventBus.$emit('onLoaderFinish');
						this.$toastr.error('Provider Type settings save failed.', 'Error');
					});
			},
			saveSettings: function () {
				let vm = this;
				eventBus.$emit('onLoaderStart');

				axios.post('/api/' + vm.$selectedSite.slug + '/provider-types/' + vm.providerType.id + '/saveSettings', vm.settings)
					.then(response => {
						vm.settings = response.data;
						vm.selectSetting(0);
						eventBus.$emit('onLoaderFinish');
						this.$toastr.success('Provider Type settings updated successfully.');
					})
					.catch(e => {
						this.errors.record(e.response.data);
						eventBus.$emit('onLoaderFinish');
						this.$toastr.error('Provider Type settings save failed.', 'Error');
					});
			},
			makeDefault: function (id) {
				let vm = this;
				eventBus.$emit('onLoaderStart');

				axios.post('/api/' + vm.$selectedSite.slug + '/provider-types/' + vm.providerType.id + '/setDefault/' + id)
					.then(response => {
						vm.settings = response.data;
						vm.selectSetting(0);
						eventBus.$emit('onLoaderFinish');
						this.$toastr.success('Provider Type settings set new default successfully.');
					})
					.catch(e => {
						this.errors.record(e.response.data);
						eventBus.$emit('onLoaderFinish');
						this.$toastr.error('Provider Type settings save failed.', 'Error');
					});
			},
			deleteSetting: function () {
				let vm = this;
				eventBus.$emit('onLoaderStart');

				if (vm.selectedSetting.hasOwnProperty('id')) {
					axios.delete('/api/' + vm.$selectedSite.slug + '/provider-types/' + vm.providerType.id + '/deleteSetting/' + vm.selectedSetting.id)
						.then(response => {
							if (response.data) {
								vm.settings = response.data;
								vm.selectSetting(0);
							} else {
								vm.settings = null;
								vm.selectedSetting = null;
							}
							eventBus.$emit('onLoaderFinish');
							this.$toastr.success('Provider Type settings set new default successfully.');
						})
						.catch(e => {
							this.errors.record(e.response.data);
							eventBus.$emit('onLoaderFinish');
							this.$toastr.error('Provider Type settings delete failed.', 'Error');
						});
				} else {
					vm.settings.splice(vm.selectedSettingIndex, 1);
					if (vm.settings.length > 0) {
						vm.selectSetting(vm.settings.findIndex(x => x !== undefined));
					} else {
						vm.selectedSetting = null;
					}

					eventBus.$emit('onLoaderFinish');
				}
			}
		}
	}
</script>

<style scoped>

</style>
